export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/ob-step-5.png?d8c053004b9e67f6b6bb68cbbb5f0754";